import React from "react";

const FactsSkeleton: React.FC = () => {
  return (
    <div>
      <div className="h-14 max-sm:h-8 max-sm:w-full w-96 max-md:w-56 skeleton"></div>
      <div className="flex items-center justify-center max-sm:flex-wrap gap-2">
        <div className="h-[500px] max-w-[500px] w-full skeleton"></div>
        <div className="h-[500px] max-w-[500px] w-full skeleton mt-56"></div>
      </div>
    </div>
  );
};
export default FactsSkeleton;
